<template>
  <div class="hello">
    <h1 class="text-4xl font-bold m-4">Page NotFound</h1>
  </div>
</template>

<script>
  export default {};
</script>